import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { C } from "../../data/content";
import { DATE_LABEL, SESSIONS } from "./Countdown";

const API = process.env.REACT_APP_BACKEND_URL;

export const RegFormV2 = ({ attribution, tid = "reg" }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ firstName: "", email: "", phone: "", session: "" });
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!consent) { setError("Please check the consent box to save your seat."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/api/ghl-lead`, {
        ...form,
        lastName: "",
        state: "",
        consent: true,
        consentText: C.consentText,
        consentTimestamp: new Date().toISOString(),
        ...attribution,
      });
      navigate("/thank-you");
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Please try again.");
      setBusy(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-[#EAECF0] shadow-[0_8px_40px_rgba(16,24,40,0.08)] p-6 md:p-7 scroll-mt-24" data-testid={`${tid}-form-card`}>
      <p className="text-[11px] font-bold tracking-[0.2em] text-[#444CE7] mb-1">FREE LIVE WEBINAR</p>
      <h3 className="text-xl font-black text-[#1D2939] mb-1">Save Your Seat</h3>
      <p className="text-[13px] text-[#475467] mb-5">{DATE_LABEL} · ~60 minutes</p>
      <form onSubmit={submit} className="space-y-3" data-testid={`${tid}-form`}>
        <input required className="field-v2" placeholder="First name" value={form.firstName} onChange={set("firstName")} data-testid={`${tid}-first-name-input`} />
        <input required type="email" className="field-v2" placeholder="Email address" value={form.email} onChange={set("email")} data-testid={`${tid}-email-input`} />
        <input required type="tel" className="field-v2" placeholder="Mobile phone" value={form.phone} onChange={set("phone")} data-testid={`${tid}-phone-input`} />
        <select required className="field-v2" value={form.session} onChange={set("session")} data-testid={`${tid}-session-select`}>
          <option value="" disabled>Choose your session</option>
          {SESSIONS.map((s) => <option key={s.id} value={s.label}>{s.label}</option>)}
        </select>
        <label className="flex gap-2.5 items-start cursor-pointer">
          <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-[#444CE7]" data-testid={`${tid}-consent-checkbox`} />
          <span className="text-[10.5px] leading-relaxed text-[#98A2B3]">{C.consentText}</span>
        </label>
        {error && <p className="text-xs text-red-500" data-testid={`${tid}-form-error`}>{error}</p>}
        <button type="submit" disabled={busy} data-testid={`${tid}-submit-button`}
          className="w-full bg-[#444CE7] hover:bg-[#3538CD] disabled:opacity-60 text-white font-bold text-[15px] py-4 rounded-full transition-all hover:shadow-[0_8px_24px_rgba(68,76,231,0.35)]">
          {busy ? "Saving your seat..." : "Save My Seat →"}
        </button>
        <p className="text-[11px] text-[#98A2B3] text-center">Free · No obligation · No hard credit pull to attend</p>
      </form>
    </div>
  );
};
